import { ActionContext, ActionExecutor } from '../baseAction.types'
import { TrackAction } from './trackAction.types'
import tracking from 'src/shared/tracking'

export class TrackActionExecutor implements ActionExecutor {
  execute(action: TrackAction, context: ActionContext): void {
    tracking.track(action.data.tag, action.data.extras)
  }
}
